import {FormControl,FormLabel,Input,  Button, ButtonGroup , Flex,  Select, Tooltip } from '@chakra-ui/react'
import { useForm } from "react-hook-form";
import { Klaonica } from '../../util/apiKlaonica';



const KlaonicaView = ({klaonica,readonly,onSave,onCancel,size='xs'}) => {
    
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data, event) => {
        event.preventDefault();
        const _kl=new Klaonica(klaonica.id,data.sifra,data.oib,data.mb,data.naziv,data.mjesto,data.ulkbr,data.pbr,
            data.posta,data.opcina,data.zupanija);
            
        
        onSave(_kl)
    }
    const onCancelClick=(event)=>{
        onCancel();
    }

    

    const PreventEnter=(e)=>{
        e.keyCode===13 && e.preventDefault();
    }

    return (
        <Flex direction={'column'} scrollBehavior={'auto'}>
        <form onSubmit={handleSubmit(onSubmit)} onKeyDown={PreventEnter}>
        <Input focusBorderColor='grunt2.400' size={size} size={size} type={'hidden'} {...register("id")}></Input>
        
            
            
            <Flex direction={'row'} gap={'0.3rem'}>
            <FormControl mb={'0.5rem'} isInvalid={errors.sifra} isReadOnly={readonly} w={'30rem'}>
                <FormLabel fontSize={size}>Šifra</FormLabel>
                <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white'  isDisabled={!errors.sifra}>
                    <Input focusBorderColor='grunt2.400' size={size} variant={'filled'} maxLength={10} {...register("sifra",{required:true})} autoCapitalize={'characters'} defaultValue={klaonica.sifra}></Input>
                </Tooltip>
            </FormControl>
            <FormControl mb={'0.5rem'} isInvalid={errors.naziv} isReadOnly={readonly}>
                    <FormLabel fontSize={size}>Naziv</FormLabel>
                    <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white' isDisabled={!errors.naziv}>
                        <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("naziv",{required:true})} defaultValue={klaonica.naziv}></Input>
                    </Tooltip>
            </FormControl>
            </Flex>
            <Flex direction={'row'} gap={'0.3rem'}>
            <FormControl mb={'0.5rem'} isInvalid={errors.oib} isReadOnly={readonly}>
                <FormLabel fontSize={size}>OIB</FormLabel>
                <Tooltip hasArrow label='OIB mora biti broj dužine 11 znamenki' bg='red' color='white'  isDisabled={!errors.oib}>
                    <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={11} {...register("oib",{pattern:/(^[0-9]{11}$|^$)/i})} defaultValue={klaonica.oib}></Input>
                </Tooltip>
            </FormControl>
            <FormControl mb={'0.5rem'} isInvalid={errors.mb} isReadOnly={readonly}>
                <FormLabel fontSize={size}>MB</FormLabel>
                <Tooltip hasArrow label='MB mora biti broj dužine 8 ili 12 znamenki' bg='red' color='white'  isDisabled={!errors.mb}>
                    <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={12} {...register("mb",{pattern:/(^[0-9]{8,12}$|^$)/i})} defaultValue={klaonica.mb}></Input>
                </Tooltip>
            </FormControl>
            </Flex>
            <Flex direction={'row'} gap={'0.3rem'}>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Mjesto</FormLabel>
                <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("mjesto")} defaultValue={klaonica.mjesto}></Input>
            </FormControl>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Ulica i kbr</FormLabel>
                <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("ulkbr")} defaultValue={klaonica.ulkbr}></Input>
            </FormControl>
            </Flex>
            <Flex direction={'row'} gap={'0.3rem'} >
            <FormControl mb={'0.5rem'} width={'30rem'} isInvalid={errors.pbr} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Poštanski broj</FormLabel>
                <Tooltip hasArrow label='Poštanski broj mora biti dužine 5 znamenaka' bg='red' color='white'  isDisabled={!errors.pbr}>
                    <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={5} {...register("pbr",{pattern:/(^[0-9]{5}$|^$)/i})} defaultValue={klaonica.pbr}></Input>
                </Tooltip>
            </FormControl>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Pošta</FormLabel>
                <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("posta")} defaultValue={klaonica.posta}></Input>
            </FormControl>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Općina</FormLabel>
                <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("opcina")} defaultValue={klaonica.opcina}></Input>
            </FormControl>
            </Flex>
            <Flex direction={'row'} gap={'0.3rem'}>
            <FormControl mb={'1rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Županija</FormLabel>
                <Select focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("zupanija")} defaultValue={klaonica.zupanija} isDisabled={readonly}>
                    <option value="-">-</option>
                    <option value="ZAGREBAČKA">ZAGREBAČKA</option>
                    <option value="SISAČKO-MOSLAVAČKA">SISAČKO-MOSLAVAČKA</option>
                    <option value="KARLOVAČKA">KARLOVAČKA</option>
                    <option value="KRAPINSKO-ZAGORSKA">KRAPINSKO-ZAGORSKA</option>
                    <option value="VARAŽDINSKA">VARAŽDINSKA</option>
                    <option value="KOPRIVNIČKO-KRIŽEVAČKA">KOPRIVNIČKO-KRIŽEVAČKA</option>
                    <option value="BJELOVARSKO-BILOGORSKA">BJELOVARSKO-BILOGORSKA</option>
                    <option value="PRIMORSKO-GORANSKA">PRIMORSKO-GORANSKA</option>
                    <option value="LIČKO-SENJSKA">LIČKO-SENJSKA</option>
                    <option value="VIROVITIČKO-PODRAVSKA">VIROVITIČKO-PODRAVSKA</option>
                    <option value="POŽEŠKO-SLAVONSKA">POŽEŠKO-SLAVONSKA</option>
                    <option value="BRODSKO-POSAVSKA">BRODSKO-POSAVSKA</option>
                    <option value="ZADARSKA">ZADARSKA</option>
                    <option value="OSJEČKO-BARANJSKA">OSJEČKO-BARANJSKA</option>
                    <option value="ŠIBENSKO-KNINSKA">ŠIBENSKO-KNINSKA</option>
                    <option value="VUKOVARSKO-SRIJEMSKA">VUKOVARSKO-SRIJEMSKA</option>
                    <option value="SPLITSKO-DALMATINSKA">SPLITSKO-DALMATINSKA</option>
                    <option value="ISTARSKA">ISTARSKA</option>
                    <option value="DUBROVAČKO-NERETVANSKA">DUBROVAČKO-NERETVANSKA</option>
                    <option value="MEĐIMURSKA">MEĐIMURSKA</option>
                    <option value="GRAD ZAGREB">GRAD ZAGREB</option>
                </Select>
            </FormControl>
            
            </Flex>
            <ButtonGroup gap={'2rem'}>
                {readonly?<></>:<Button type={'submit'} colorScheme={'grunt2'} size={size}>Spremi</Button>}
                <Button colorScheme={'grunt2'} variant={'outline'} size={size} onClick={onCancelClick}>Odustani</Button>
            </ButtonGroup>
        </form>
        </Flex>
    );
}

export default KlaonicaView;
